
import { useUserProfile } from "./use-user-profile";
import { MessageTone } from "@/types/message";

export const useSubscriptionFeatures = () => {
  const { userData } = useUserProfile();
  
  // Check if user has an active subscription - more robust checking
  const isSubscribed = userData?.subscription_tier === "pro";
  
  console.log("=== SUBSCRIPTION FEATURES DEBUG ===");
  console.log("Environment:", window.location.hostname);
  console.log("User data:", userData);
  console.log("Subscription tier:", userData?.subscription_tier);
  console.log("Is subscribed:", isSubscribed);
  
  // Get available tones based on subscription
  const getAvailableTones = (): MessageTone[] => {
    const baseTones: MessageTone[] = ["polite", "friendly"];
    
    if (isSubscribed) {
      console.log("Pro user detected - returning all tones");
      const allTones: MessageTone[] = ["legal", "polite", "aggressive", "friendly", "custom"];
      console.log("All tones for pro user:", allTones);
      return allTones;
    }
    
    console.log("Free user - returning basic tones only:", baseTones);
    return baseTones;
  };
  
  // Check if user can access a specific tone
  const canAccessTone = (tone: MessageTone): boolean => {
    const availableTones = getAvailableTones();
    const canAccess = availableTones.includes(tone);
    console.log(`Tone access check for ${tone}:`, canAccess, "Available:", availableTones);
    return canAccess;
  };
  
  // Check if user can access premium features
  const canAccessPremiumFeatures = (): boolean => {
    const canAccess = isSubscribed;
    console.log("Premium features access:", canAccess);
    return canAccess;
  };
  
  // Check if user can access platform intelligence
  const canAccessPlatformIntelligence = (): boolean => {
    const canAccess = isSubscribed;
    console.log("Platform intelligence access:", canAccess);
    return canAccess;
  };
  
  // Flight compensation feature is temporarily disabled
  const canAccessFlightCompensation = (): boolean => {
    const canAccess = false; // Feature disabled
    console.log("Flight compensation access (DISABLED):", canAccess);
    return canAccess;
  };
  
  // Flight letter generation is temporarily disabled
  const canGenerateFlightLetter = (): boolean => {
    const canAccess = false; // Feature disabled
    console.log("Flight letter generation access (DISABLED):", canAccess);
    return canAccess;
  };
  
  return {
    isSubscribed,
    getAvailableTones,
    canAccessTone,
    canAccessPremiumFeatures,
    canAccessPlatformIntelligence,
    canAccessFlightCompensation,
    canGenerateFlightLetter
  };
};
